import { KnowledgeBaseVisibilityType } from 'types/KnowledgeBaseVisibilityType'

const defaultValues = {
  files: [],
  visibility: KnowledgeBaseVisibilityType.Company,
  description: ''
}

export {
  defaultValues,
}
